// Explicit public reads only. Adding a write or account endpoint here is not safe.
const publicReads = new Set([
  'get /api-news/chain/chainList',
  'get /api-news/chain/chainListSol',
  'get /api-news/chain/chainMenu',
  'get /api-news/etf/bitcoin/list',
  'get /api-news/etf/ethereum/list',
  'get /api-news/fundingRate/fundingRateExchange',
  'get /api-news/fundingRate/menu',
  'get /api-news/hyperliquid/userPosition',
  'get /api-news/hyperliquid/whalePosition',
  'get /api-news/inscription/inscriptionList',
  'get /api-news/inscription/inscriptionMenu',
  'get /api-news/inscription/inscriptionTokenList',
  'get /api-news/inscription/inscriptionTokenMsg',
  'get /api-news/large/LargeTransaction',
  'get /api-news/large/exchangeBalanceList',
  'get /api-news/large/holdingsList',
  'get /api-news/large/largeCount',
  'get /api-news/large/largeMenu',
  'get /api-news/liquidation/coins',
  'get /api-news/liquidation/exchange',
  'get /api-news/liquidation/heatmap',
  'get /api-news/liquidation/liquidationAggregatedHistory',
  'get /api-news/liquidation/liquidationExchange',
  'get /api-news/liquidation/liquidationMap',
  'get /api-news/liquidation/liquidationProportion',
  'get /api-news/liquidation/liquidationRanking',
  'get /api-news/liquidation/openInterestList',
  'get /api-news/liquidation/takerBuySellVolume',
  'get /api-news/liquidation/threeExchangeSummary',
  'get /api-news/liquidation/topLongShortAccountRatio',
  'get /api-news/liquidation/topLongShortPositionRatio',
  'get /api-news/market/exchangeDetail',
  'get /api-news/market/markets2',
  'get /api-news/news/announcements',
  'get /api-news/news/articles',
  'get /api-news/news/briefs',
  'get /api-news/news/getKline',
  'get /api-news/news/newCoinKline',
  'get /api-news/news/newCoinMarket',
  'get /api-news/news/newsShare',
  'get /api-news/news/ticker24h',
  'get /api-news/other/appList',
  'get /api-news/other/smartMoney',
  'get /api-news/other/smartMoneyList',
  'get /api-news/other/smartMoneyList3',
  'get /api-news/util/btcCompanyHoldings',
  'get /api-news/util/fearGreed',
  'get /api-news/util/largePosition',
  'get /api-news/util/mTGox',
  'get /api-news/util/oTCPrice',
  'get /api-news/util/outDisk',
  'get /api-news/util/stableChainMining',
  'get /api-news/util/stablePrem',
  'get /api-news/util/stableSupplyTrend',
  'get /api-news/util/stableUSDTKline',
  'get /api-news/util/stableUSDTOuterDisk',
  'post /dex-api/okx/hotrank',
  'post /dex-api/okx/allcoins',
  'post /dex-api/okx/updownrank',
  'post /dex-api/okx/newcoinrank',
  'post /dex-api/okx/hotfeverrank',
  'post /dex-api/okx/marketcaprank',
  'post /dex-api/okx/turnoverrank',
  'post /dex-api/okx/candles',
  'post /dex-api/okx/coindetail',
  'post /dex-api/okx/coininfo',
  'post /dex-api/okx/multtickers',
  'post /dex-api/okxdex/coinlist',
  'post /dex-api/okxdex/getchian',
  'post /dex-api/okxdex/candles',
  'post /dex-api/okxdex/holderlist',
  'post /dex-api/okxdex/poolslist',
  'post /dex-api/okxdex/tradehistory',
  'post /dex-api/app/getchian',
]);
export function isPublicRead(method, url, params = {}) {
  if (method === 'post' && url === '/dex-api/jin10') return ['/get/data', '/get/event'].includes(params.method);
  return publicReads.has(method + ' ' + url);
}

const clone = value => JSON.parse(JSON.stringify(value));
// ponytail: bounded, memory-only cache; five seconds for market data, one minute for menus.
export function createPublicReadCache(now = Date.now) {
  const entries = new Map();
  const pending = new Map();
  const stable = value => {
    if (Array.isArray(value)) return value.map(stable);
    if (value && typeof value === 'object') return Object.keys(value).sort().reduce((out, key) => {
      out[key] = stable(value[key]); return out;
    }, {});
    return value;
  };
  return function read({ method, url, params, scope, config = {} }, fetch) {
    if (!isPublicRead(method, url, params) || config.signal || config.cancelToken || config.cache === false) return fetch();
    const key = JSON.stringify([method, url, stable(params), scope]);
    const entry = entries.get(key);
    if (entry && now() < entry.expires) return Promise.resolve(clone(entry.value));
    entries.delete(key);
    if (!pending.has(key)) {
      const ttl = /(?:Menu|getchian|allcoins|\/coins)$/.test(url) ? 60000 : 5000;
      const request = Promise.resolve().then(fetch).then(value => {
        if (value && value.code === 0 && JSON.stringify(value).length <= 512000) {
          entries.delete(key);
          entries.set(key, { value: clone(value), expires: now() + ttl });
          while (entries.size > 40) entries.delete(entries.keys().next().value);
        }
        return value;
      }).finally(() => pending.delete(key));
      pending.set(key, request);
    }
    return pending.get(key).then(clone);
  };
}
